// extracted by mini-css-extract-plugin
export default {"card":"remove-appointment_card__nJtpU","title":"remove-appointment_title__cVB40","text":"remove-appointment_text__hqDYm","btns":"remove-appointment_btns__PGJ43"};